import { FC, useState } from 'react'
import { useTranslate } from 'react-polyglot'
import { Menu, MenuSection } from '@getgo/chameleon-web-react-wrapper'
import { Box, Grid } from '@material-ui/core'

import { ManagedAccountsByPartner } from 'hooks/useManagedAccounts'
import { Account } from 'types/Account'
import { useStyles } from './AccountMenuForPartners'
import MainMenuItem from './MainMenuItem'
import Section from './Section'

interface MultiplePartnersProps {
  accounts: Account[]
  managedAccountsByPartner: ManagedAccountsByPartner[]
  onSelectAccount: (account: Account) => void
}

const MultiplePartners: FC<MultiplePartnersProps> = ({
  accounts,
  managedAccountsByPartner,
  onSelectAccount,
  ...props
}) => {
  const t = useTranslate()
  const [accountListTitle, setAccountListTitle] = useState<string>(t('My Accounts'))
  const [accountList, setAccountList] = useState<Account[]>(accounts)
  const classes = useStyles()

  const setMyAccounts = () => {
    setAccountListTitle(t('My Accounts'))
    setAccountList(accounts)
  }

  return (
    <>
      <Grid data-testid="multiple-partners" className={classes.mainMenu} item xs={5} {...props}>
        <Menu>
          <MainMenuItem
            data-testid={'my-accounts-main-menu-item'}
            name={t('My Accounts')}
            count={accounts.length}
            onClick={setMyAccounts}
          />
          <MenuSection className={classes.menuSection} title={t('Partner Accounts')}>
            {t('Partner Accounts')}
          </MenuSection>
          {managedAccountsByPartner.map(({ partnerAccount: { name, key }, customerAccounts }) => (
            <MainMenuItem
              data-testid={`partner-account-${key}-main-menu-item`}
              key={key}
              name={name}
              count={customerAccounts.length}
              onClick={() => {
                setAccountList(customerAccounts)
                setAccountListTitle(`${t('Customer Accounts')} - ${name}`)
              }}
            >
              {name}
            </MainMenuItem>
          ))}
        </Menu>
      </Grid>

      <Grid className={classes.accountListHolder} item xs>
        <Box className={classes.accountList}>
          <Section title={accountListTitle} accounts={accountList} onClick={onSelectAccount} />
        </Box>
      </Grid>
    </>
  )
}

export default MultiplePartners
